
@switch (status) {
  @case (PoState.Bypassed) {
    <span nz-icon nzType="eye-invisible" nzTheme="twotone"></span>
  }
  @case (PoState.Running) {
    <span nz-icon nzType="play-circle" nzTheme="twotone"></span>
  }
  @case (PoState.IsInspected) {
    <span nz-icon nzType="sync" nzSpin></span>
  }
  @case (PoState.Approved) {
    <span nz-icon nzType="check-circle" nzTheme="twotone"
    nzTwotoneColor="#52c41a"></span>
  }
  @case (PoState.Split) {
    <span nz-icon nzType="scissor"></span>
  }
  @case (PoState.Stalled) {
    <span nz-icon nzType="stop" nzTheme="twotone"
    nzTwotoneColor="#eb932f"></span>
  }
  @case (PoState.Suspended) {
    <span nz-icon nzType="pause-circle" nzTheme="twotone"
    nzTwotoneColor="#eb932f"></span>
  }
  @case (PoState.Ignored) {
    <span nz-icon nzType="minus-circle" nzTheme="twotone"
    nzTwotoneColor="#eb932f"></span>
  }
  @default {
    <span nz-icon nzType="question-circle" nzTheme="twotone"
    nzTwotoneColor="#eb932f"></span>
  }
}
